export default {
  TYPE: {
    ORDER: 'ORDER',
    ORDER_FREE: 'ORDER_FREE',
    GET_FREE: 'GET_FREE',
    BUY: 'BUY'
  },
  FILTER_TYPE: {
    MOBILE: 'Mobile',
    LOCAL: 'Local',
    TOLL_FREE: 'Toll-Free'
  }
};
